import { Component, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from "@angular/animations";
import { Compbaser } from "../../../components/compbaser/compbases";
import { ChildrenOutletContexts } from '@angular/router';
import { Memoizee } from "../../../decorators/memoizee-decorator";

@Component({
  selector: 'app-resources-entry',
  templateUrl: './resources-entry.component.html',
  styleUrls: ['./resources-entry.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition('* => *', [
        style({ opacity: 0 }),
        animate('300ms ease-in-out')
      ])
    ])
  ]
})
export class ResourcesEntryComponent extends Compbaser implements OnInit {

  constructor(private contexts: ChildrenOutletContexts) {
    super();
  }

  ngOnInit() {
  }

  @Memoizee({})
  getState() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
  }
}
